import type { Dimensions } from "../Dimensions";
import { getStylesWithBreakpoints } from "../utils";

/**
 * Generates grid column CSS styles based on the provided columns.
 * @param {number | number[]} columns - The number of columns for the grid.
 * @returns {string} - The generated CSS string for grid columns.
 */
export const generateGridColumnStyles = (columns: number | number[]): string => {
    return getStylesWithBreakpoints(columns, (value) => `grid-template-columns: repeat(${value}, 1fr);`);
};

/**
 * Generates grid gap CSS styles based on the provided gap values.
 * @param {Dimensions | Dimensions[]} gap - The general gap values for the grid.
 * @param {Dimensions | Dimensions[]?} rowGap - The row-specific gap values. Falls back to `gap` if not provided.
 * @param {Dimensions | Dimensions[]?} columnGap - The column-specific gap values. Falls back to `gap` if not provided.
 * @returns {string} - The generated CSS string for grid gaps.
 */
export const generateGridGapStyles = (
    gap: Dimensions | Dimensions[],
    rowGap?: Dimensions | Dimensions[],
    columnGap?: Dimensions | Dimensions[],
): string => {
    const gapStyles = getStylesWithBreakpoints(gap, (value) => `gap: ${value};`);
    const rowGapStyles = getStylesWithBreakpoints(rowGap || gap, (value) => `row-gap: ${value};`);
    const columnGapStyles = getStylesWithBreakpoints(columnGap || gap, (value) => `column-gap: ${value};`);

    return `${gapStyles} ${rowGapStyles} ${columnGapStyles}`;
};
